import React from "react";

const StatCard = ({ icon: Icon, label, value, hint }) => (
  <div className="ht-card rounded-2xl bg-white border border-[#e6eef5] p-6 shadow-sm">
    <div className="flex items-center justify-between">
      <p className="ht-body text-sm text-[#5a6b7d]">{label}</p>
      <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#eaf4fb] text-[#3d6486]">
        <Icon className="h-4 w-4" />
      </span>
    </div>
    <p className="mt-3 ht-display text-3xl text-[#2c3e50]">{value}</p>
    {hint && <p className="mt-1 text-xs text-[#7e8a96]">{hint}</p>}
  </div>
);

export default StatCard;
